import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const unregisteredFlats = createAsyncThunk(
  "unregisteredFlats",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/dashboard/unregistered-flats/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);
const initialState = {
  isLoading: false,
  unregisteredFlatsData: null,
  isError: false,
  errorMessage: "",
};

const unregisteredFlatsSlice = createSlice({
  name: "unregisteredFlats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(unregisteredFlats.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(unregisteredFlats.fulfilled, (state, action) => {
      state.isLoading = false;
      state.unregisteredFlatsData = action.payload;
    });
    builder.addCase(unregisteredFlats.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default unregisteredFlatsSlice.reducer;
